module.exports = __webpack_public_path__ + "img/pvc_600g_farbauswahl_blau_rot_orange.f0544aa8.jpg";